<template>
  <div>
    <div class="position-relative">
      <section class="section-shaped my-0">
        <bubbles-background></bubbles-background>
        <div class="container container-lg pb-4 shape-container">
          <card shadow class="card-profile mt-4 border-0" no-body>
            <vertical-ptwist-modules></vertical-ptwist-modules>
            <card-header title="Repositories" :icon="{prefix:'fas', iconName: 'box-open'}"
                         :text="pageText"></card-header>
            <div class="px-4 pb-3">
              <div class="mb-3 row">
                <div class="col-md-12">
                  <base-button class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeSource('thingiverse')"
                               :class="[ source === 'thingiverse' ? 'bg-thingiverse text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fab', iconName: 'tumblr'}">
                    Thingiverse
                  </base-button>
                  <base-button class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeSource('flickr')"
                               :class="[ source === 'flickr' ? 'bg-flickr text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fab', iconName: 'flickr'}">
                    Flickr
                  </base-button>
                  <base-button class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeSource('external')"
                               :class="[ source === 'external' ? 'bg-ptwist text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'external-link-square-alt'}">
                    External Sources
                  </base-button>
                  <base-button class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeSource('pilot-suggestions')"
                               :class="[ source === 'pilot-suggestions' ? 'bg-ptwist text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'lightbulb'}">
                    Pilot Suggestions
                  </base-button>

                </div>
              </div>
              <div v-if="source ==='thingiverse'">
                <thingiverse-repository></thingiverse-repository>
              </div>

              <div v-if="source === 'flickr'">
                <flickr-repository></flickr-repository>
              </div>
              <div v-if="source === 'external'">
                <external-sources></external-sources>
              </div>
              <div v-if="source === 'pilot-suggestions'">
                <pilot-suggestions></pilot-suggestions>
              </div>
            </div>
          </card>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import ExternalSources from '../components/ExternalSources'
import PilotSuggestions from '../components/PilotSuggestions'
import FlickrRepository from '../components/FlickrRepository'
import ThingiverseRepository from '../components/ThingiverseRepository'
import { getInfoText } from '../info'
import VerticalPtwistModules from '@/components/VerticalPtwistModules.vue'

export default {
  name: 'repository',
  components: {
    'external-sources': ExternalSources,
    'flickr-repository': FlickrRepository,
    'thingiverse-repository': ThingiverseRepository,
    'pilot-suggestions': PilotSuggestions,
    VerticalPtwistModules
  },
  data () {
    return {
      dataReady: false,
      source: 'thingiverse',
      pageText: getInfoText('repositories')
    }
  },
  watch: {
    source (newSource) {
      if (newSource === 'external') {
        this.dataReady = true
      }
    }
  },
  methods: {
    changeSource (source) {
      this.source = source
    }
  }
}
</script>
